/* eslint-disable max-len */
import React, { FunctionComponent } from 'react';

import { Breakpoint, Card, Heading, Product } from '@savebetter/components';

import { isValidHexColor } from '../utils/color';

import { getLayoutTypeClasses, LayoutType } from './ProductComparison';
import { Section } from './Section';

// would be nice to import this color from tailwind.config file
const bgPrimary = '#156CC4';

interface FeaturedProductCardProps {
  product: Product;
  bankHexColor?: string;
  apyTitleColor: string;
  productComparisonValue: string;
  layoutType: LayoutType;
  viewportType: Breakpoint;
}

const FeaturedProductCard: FunctionComponent<FeaturedProductCardProps> = ({
  bankHexColor,
  apyTitleColor,
  productComparisonValue,
  product: { annualPercentageYield, bankName, bankLogoUrl, productName },
  layoutType,
  viewportType
}) => {
  const layoutTypeClasses = getLayoutTypeClasses(viewportType, layoutType);
  const bgColor = bankHexColor && isValidHexColor(bankHexColor) ? bankHexColor : bgPrimary;

  return (
    <Card
      horizontalPaddingClassName="none"
      shadow="shadow-none"
      rounded="rounded-md"
      className={`${layoutTypeClasses} relative box-border md:mx-0 border-none shadow-md pt-0 md:mr-4`}
    >
      <Heading
        className={`w-full m-0 py-4 text-center absolute top-0 rounded-t-rounded ${apyTitleColor}`}
        kind="3"
        level="3"
        bgColor={bgColor}
      >
        {annualPercentageYield}
      </Heading>
      <Section className="pt-14">
        <div className="pt-10 px-6 flex justify-around">
          <div className="w-1/2 pr-2">
            <p className="break-word">{productName}</p>
          </div>
          <div className="w-1/2 pl-8 flex justify-end items-center">
            <img className="w-full" src={bankLogoUrl} alt={bankName} />
          </div>
        </div>
        <div className="absolute w-max -bottom-3 left bg-secondary py-1 px-2 text-sm inset-x-0 mx-auto my-0 text-center">
          <span className="font-semibold">{productComparisonValue}</span> more
        </div>
      </Section>
    </Card>
  );
};

export default FeaturedProductCard;
